// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
//

import { myAccountDashboardTitleStyles } from "@ces/App/Widgets/MyAccount/MyAccountDashboardTtile";
import { xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

myAccountDashboardTitleStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;
        
        ${xScreen("lt", "sm")} {
            flex-direction: column;
            align-items: flex-start;
        }
    `,
};

myAccountDashboardTitleStyles.myDashboardTitleWrapper = {
    css: css`
        h1 {
            margin-bottom: 0px;
        }
    `,
};


